import type { FaireProductEntity } from "../../entity_types/product";

export const p_4352wtknkm: FaireProductEntity = {
  token: "p_4352wtknkm",
  type: "product",
  name: "Long Sleeve Striped Cardigan Sweater",
  brandToken: "b_4z8um3dept",
  brandName: "Sheer Trend",
  imageUrl:
    "https://cdn.faire.com/fastly/a99f948fb0d7052ad61fa9053a55e922886207a01fbbf8be78ee001ccb60ceee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62a1d5d752a0286b14818b4c07d1c954ede7f07071387bc45f71438cf47ab1bf.jpeg",
    "https://cdn.faire.com/fastly/614b582b69645a551ceafaaf0b807522d0b1cf918335967d3d615ae9beccbb23.jpeg",
    "https://cdn.faire.com/fastly/3142aaf09d6e41f94b525777cb0486bd55bb091f259142175de9329f424c3e96.jpeg",
    "https://cdn.faire.com/fastly/8315a5687c4cd412ec2b796ab3e628256160bfbf42822801c648cf6200a49459.jpeg",
  ],
  priceDollars: 24.49,
  description:
    "Material:Acrylic\n\nStyle:Loose,Cute,Intellectual,All-match\n\nFeature:Striped\n\nNeckline:V-neck\n\nOccasion:Going out,Casual,Artistic Retro,Girlish Sweetness,Light Maturity,Leisure Fashion\n\nSeasons:Spring,Autumn\n\nType:Sweater\n\nSleeve Length:Long Sleeve\n\nSleeve Style:Raglan Sleeve\n\nSize S (inch) : Bust= 40.56 ; Sleeve= 25.74 ; Length= 31.98 ; \n\nSize M (inch) : Bust= 42.12 ; Sleeve= 26.21 ; Length= 32.37 ; \n\nSize L (inch) : Bust= 44.46 ; Sleeve= 26.91 ; Length= 32.96 ; \n\nDiscover our stylish **Solid Color Sleeveless Soft Stretch Crop Top** – perfect for **casual, office, or urban outings**. Made from **breathable polyester**, this **loose, unlined tank top** offers a **lithe, classic British-style** fit. Featuring a **round-neck design**, it's ideal for **spring, summer, and autumn** wardrobes. Elevate your look with this **versatile sleeveless crop top**! \n\n#Solid Color Sleeveless Crop Top, #Soft Stretch Crop Top, #Polyester Sleeveless Top, #Loose Fit Crop Top, #Unlined Sleeveless Top, #Classic British-style Top, #Round-neck Tank Top, #Casual Office Crop Top, #Urban Tune Sleeveless Top, #Summer Sleeveless Crop Top,\n",
  tags: [],
  msrpDollars: 48.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:54.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
